import React from "react"
import { SvgIcon } from "@material-ui/core"

function MicSlashIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id="Mic"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7215 15.873C13.9076 16.34 12.9669 16.6 12 16.6C9.46998 16.6 7.11998 14.83 6.74998 12.21C6.68998 11.8 6.32998 11.5 5.91998 11.5C5.39998 11.5 4.99998 11.96 5.06998 12.47C5.52998 15.44 8.02998 17.77 11 18.22V20.5C11 21.05 11.45 21.5 12 21.5C12.55 21.5 13 21.05 13 20.5V18.22C14.0586 18.0662 15.0596 17.6669 15.9299 17.0814L14.7215 15.873ZM13.1291 14.2806C12.7813 14.4221 12.4002 14.5 12 14.5C10.34 14.5 9 13.16 9 11.5V10.1515L13.1291 14.2806ZM9.05838 4.90659C9.3329 3.53199 10.5432 2.5 12 2.5C13.66 2.5 15 3.84 15 5.5L14.9911 10.8393L9.05838 4.90659ZM18.3886 14.2368L17.0901 12.9383C17.1606 12.7038 17.2144 12.4607 17.25 12.21C17.31 11.8 17.66 11.5 18.08 11.5C18.6 11.5 19 11.96 18.93 12.47C18.834 13.0899 18.6487 13.6828 18.3886 14.2368Z"
      />
      <rect
        id="Slash"
        x="6"
        y="2.91096"
        width="19.5"
        height="2.25"
        rx="1.125"
        transform="rotate(45 6 2.91096)"
      />
    </SvgIcon>
  )
}

export default MicSlashIcon
